// ═══════════════════════════════════════════════════════════════════════════
// FILE: src/app/components/agent-status/agent-status.component.ts
// DATE: 2026-11-02
// CREATOR: PIA (Rolle HUGO), beauftragt vom PO am 02.11.2026
// ceeq.it: _40 · KI-Agent-Statusanzeige, Schritt 2
//
// PURPOSE
//   Kleine Ampel unten rechts auf jeder Projektseite (/project/<pslot>/…): ein Punkt je
//   Agent mit Zugang zum pslot. Klick klappt die Liste auf: Name, @Handle, Hinweis, was zu
//   tun ist, wartende Anfragen — und der Sprung zu „Waiting for“ im Ask-Panel (Alt+P).
//   Eingehängt in app.component.html neben Ask-Panel und Erinnerung.
//
// SEKTOREN im HTML: [S1] Pille mit Punkten · [S2] Aufklappliste · [S3] Hinweis ohne grünen Agenten
// TESTIDS: agents.pill · agents.dot-<handle> · agents.panel · agents.row-<handle> ·
//          agents.hint-<handle> · agents.waiting · agents.close
// ═══════════════════════════════════════════════════════════════════════════

import { Component, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AgentStatusService, agoOf } from '../../services/agent-status.service';
import { RequestsService } from '../../services/requests.service';

/** /project/<pslot>/… → pslot; sonst null (keine Anzeige außerhalb eines Projekts). */
export function pslotAusUrl(url: string): string | null {
  const m = /^\/project\/([^/?#]+)/.exec(url);
  return m ? decodeURIComponent(m[1]) : null;
}

@Component({
  selector: 'app-agent-status',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './agent-status.component.html',
  styleUrls: ['./agent-status.component.scss'],
})
export class AgentStatusComponent implements OnInit {
  readonly st = inject(AgentStatusService);
  private req = inject(RequestsService);
  private router = inject(Router);
  readonly agoOf = agoOf;
  readonly open = signal(false);

  ngOnInit(): void {
    this.st.follow(pslotAusUrl(this.router.url));
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => this.st.follow(pslotAusUrl(e.urlAfterRedirects)));
  }

  toggle(): void {
    this.open.update((v) => !v);
    const p = this.st.pslot();
    if (this.open() && p) void this.st.load(p);   // beim Aufklappen frisch
  }

  /** Meine offenen Anfragen („Waiting for“) im Ask-Panel zeigen. */
  showWaiting(): void {
    this.open.set(false);
    this.req.openPanel('waiting');
  }
}
